import React from "react"

interface ErrorDisplayProps {
	shadowError: string | null
	connectivityError: string | null
	onClearError: () => void
}

const ErrorDisplay: React.FC<ErrorDisplayProps> = ({
	shadowError,
	connectivityError,
	onClearError,
}) => {
	if (!shadowError && !connectivityError) {
		return null
	}

	return (
		<div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">
			<div className="flex justify-between items-center">
				<span>
					<strong>Error:</strong>
					{shadowError && <div>Shadow: {shadowError}</div>}
					{connectivityError && <div>Connectivity: {connectivityError}</div>}
				</span>
				<button onClick={onClearError} className="text-red-700 hover:text-red-900">
					×
				</button>
			</div>
		</div>
	)
}

export default ErrorDisplay
